module.exports = __webpack_public_path__ + "img/Dantam Makeover 29.162e44c8.jpg";